import { Component, OnInit } from '@angular/core';
import { Store } from "@ngrx/store";
import { ApplicationState, getProductsEmbeddedErrors, getUserProduct } from "../store/reducers";
import { OnDestroyHookDirective } from "../shared/hooks";
import { ActivatedRoute } from "@angular/router";
import { filter, take } from "rxjs/operators";
import { combineLatest } from "rxjs";
import * as ProductsActions from "../store/actions/products.actions";
import * as MagnoliaConfigActions from "../store/actions/magnolia-config.actions";
import { TranslationService } from "@proximus/ng-common";



@Component({
  selector: 'mprd-get-jwt-redirect',
  templateUrl: './get-jwt-redirect.component.html'
})
export class GetJwtRedirectComponent  extends OnDestroyHookDirective implements OnInit {
  genericErrorMessage: string | undefined;
  private accessNumber!: string;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly _store: Store<ApplicationState>,
    private readonly translationService: TranslationService
  ) {
    super();
  }

  ngOnInit(): void {
    const includeAccessNumber = this.route.snapshot.queryParamMap.get('includeAccessNumber');
    if (includeAccessNumber) {
      try {
        this.accessNumber = JSON.parse(sessionStorage.getItem('existingCustomer'))?.[includeAccessNumber];
      } catch (e) {
        console.warn('Failed to access sessionStorage', e);
      }
    }

    this.getProducts();

    this.addSubscription(
      combineLatest([
        this._store.select(getUserProduct).pipe(
          filter(userProduct => userProduct.loaded),
          take(1)
        ),
        this._store.select(getProductsEmbeddedErrors)
      ]).subscribe(([data, errors]) => {
        const rawReturnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
        if (!rawReturnUrl) {
          this.genericErrorMessage = 'No return URL provided';
          return;
        }

        const returnUrl = decodeURIComponent(rawReturnUrl);
        const separator = returnUrl.includes('?') ? '&' : '?';

        const errorEmptyInstallbase = errors?.find(error =>
          error.code === 'EMPTY_INSTALL_BASE' ||
          error.code === 'EMPTY_INSTALL_BASE_CEASE_CUST' ||
          error.code === 'EMPTY_INSTALL_BASE_NEW_CUST' ||
          error.code === 'EMPTY_INSTALL_BASE_V1'
        );

        if (errorEmptyInstallbase) {
          window.location.href = `${returnUrl}${separator}error=${errorEmptyInstallbase.code}`;
          return;
        }

        const token = data.packs?.find((pack) => {
          if (!this.accessNumber) {
            return pack.ewebToken;
          }

          return pack.coreProducts.find((product) => product.accessNumber?.slice(-3) === this.accessNumber?.slice(-3));
        })?.ewebToken || this.getOutOfPacksEwebTokenProduct(data.outOfPacks);

        window.location.href = token
          ? `${returnUrl}${separator}token=${encodeURIComponent(token)}`
          : `${returnUrl}${separator}error=ERROR_NO_TOKEN_FOUND`;
      })
    );
  }

  private getOutOfPacksEwebTokenProduct(outOfPacks: any) {
    return outOfPacks.find((pack: any) => {
      if (!this.accessNumber) {
        return pack.coreProducts.find((product: any) => product.ewebToken)
      }

      return pack.coreProducts.find((product: any) => product.accessNumber?.slice(-3) === this.accessNumber?.slice(-3));
    })?.coreProducts[0]?.ewebToken;
  }

  private getProducts() {
    const appBrand = this.translationService.getTranslatedValueFor('app.brand');
    this._store.dispatch(
      new ProductsActions.GetProducts({
        appBrand: appBrand || 'proximus',
      }),
    );
    this._store.dispatch(new MagnoliaConfigActions.GetOptionGroupsConfig())
  }
}
